<template>
  <div class="locale-changer">
    <button v-on:click="setLocale">{{ $t("switch_to_lang") }}</button>
  </div>
</template>

<script>
export default {
  methods: {
    setLocale() {
      if (this.$i18n.locale == "en") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
    }
  },
  data() {
    return { langs: ["zh", "en"] };
  }
};
</script>

<style lang="scss" scoped>
button {
  background:transparent;
  border:0;
  outline:0;
  font-family: $type-number;
  color:$hku-offwhite;
  transition:0.1s linear;
  &:active,&:hover{
    color:white;
  }
}
</style>
